import type { ViewConfigEntities } from '@cognite/apm-config';
import type { ViewReference } from '@cognite/sdk';

export const APM_Activity = 'APM_Activity';
export const APM_Notification = 'APM_Notification';
export const APM_Operation = 'APM_Operation';
export const CDM_SPACE = 'cdf_cdm' as const;
export const CDM_3D_CONTAINER_SPACE = 'cdf_cdm_3d' as const;

export const ASSET_VIEW_EXTERNAL_ID = 'Asset' as const;

export const baseNotificationViewReference: Omit<ViewReference, 'type'> = {
  externalId: APM_Notification,
  space: 'APM_SourceData',
  version: '1',
} as const;

export const baseIdmNotificationViewReference: Omit<ViewReference, 'type'> = {
  externalId: 'CogniteNotification',
  space: 'cdf_idm',
  version: 'v1',
} as const;

export const baseAssetViewReference: Omit<ViewReference, 'type'> = {
  externalId: 'Asset',
  space: 'cdf_core',
  version: 'v1',
} as const;

export const baseIdmAssetViewReference: Omit<ViewReference, 'type'> = {
  externalId: 'CogniteAsset',
  space: 'cdf_cdm',
  version: 'v1',
} as const;

export const baseActivityViewReference: Omit<ViewReference, 'type'> = {
  externalId: APM_Activity,
  space: 'APM_SourceData',
  version: '1',
} as const;

export const baseIdmActivityViewReference: Omit<ViewReference, 'type'> = {
  externalId: 'CogniteMaintenanceOrder',
  space: 'cdf_idm',
  version: 'v1',
} as const;

export const baseOperationViewReference: Omit<ViewReference, 'type'> = {
  externalId: APM_Operation,
  space: 'APM_SourceData',
  version: '1',
} as const;

export const baseIdmOperationViewReference: Omit<ViewReference, 'type'> = {
  externalId: 'CogniteOperation',
  space: 'cdf_idm',
  version: 'v1',
} as const;

export const baseIdmViewDictionary: Record<
  ViewConfigEntities,
  Omit<ViewReference, 'type'>
> = {
  MAINTENANCE_ORDER: baseIdmActivityViewReference,
  OPERATION: baseIdmOperationViewReference,
  NOTIFICATION: baseIdmNotificationViewReference,
  ASSET: baseIdmAssetViewReference,
} as const;
